import {Request, ResponseSerialize} from '@simpli/serialized-request'
import {GithubOrganization} from './GithubOrganization'
import {IResource} from '@simpli/resource-collection/dist/types/IResource'

export class GithubRepository implements IResource {
  idGithubRepositoryPk: number = 0

  @ResponseSerialize(GithubOrganization)
  githubOrganization: GithubOrganization | null = null

  name: string | null = null
  colorHex: string | null = null
  url: string | null = null
  labelsTokenized: string | null = null
  description: string | null = null
  branch: string | null = null
  stars: number | null = null
  linesOfCodeCount: number | null = null
  contributorsCount: number | null = null
  starsCount: number | null = null
  commitsCount: number | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null
  lastCommit: Date | null = null

  get $id() {
    return this.idGithubRepositoryPk
  }

  set $id(val) {
    this.idGithubRepositoryPk = val
  }

  get $tag() {
    return String(this.$id)
  }

  async getGithubRepository(id: number) {
    return await Request.get(`/client/github-repository/${id}`)
      .name('getGithubRepository')
      .as(this)
      .getResponse()
  }

  async persistGithubRepository() {
    return await Request.post(`/client/github-repository`, this)
      .name('persistGithubRepository')
      .as(this)
      .getResponse()
  }

  /**
   * Deletes an instance of a given ID of GithubRepository
   */
  async removeGithubRepository() {
    return await Request.delete(`/client/github-repository/${this.$id}`)
      .name('removeGithubRepository')
      .asNumber()
      .getData()
  }
}
